import { newRequest } from "std/api/newRequest";

export function apiSyncData(): Promise<unknown> {
	return newRequest({
		url: "Integracao/All",
		type: "get",
	});
}
